export const COMPLETED_TASK_STATUSES: string[] = [
  'AUTOPAY_FUNDED',
  'LENDER_FUNDED',
  'LENDER_FUNDED_PENDING',
  'PAYOFF_SENT',
  'PERFECTING_TITLE_AUTOPAY',
  'PERFECTING_TITLE_DEALER',
  'TITLE_QA',
];
